import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { CSSProperties } from 'react';
import '../App.css';

function ViewMusic() {
    const { no } = useParams();
    const [searchResults, setSearchResults] = useState<string[]>([]);

useEffect(() => {
        const r2BaseUrl = process.env.REACT_APP_R2_BASE_URL || '';

        fetch(`${r2BaseUrl}/music/musiclist`)
            .then(response => response.text())
            .then(data => {
                const musicArray = data.split('\n').filter(line => line.trim() !== '');
                setSearchResults(musicArray);
            })
            .catch(() => {});
    }, []); // Empty dependency array to match ViewMusic

    const displayMusic = searchResults[parseInt(no || "") - 1]

    const musicStyle: CSSProperties= {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: 'auto',
        margin: '0 auto',
    };
    const audioStyle: CSSProperties = {
        width: '90%',
        maxWidth: '40em',
    };
    const titleStyle: CSSProperties = {
        textAlign: 'center',
    };
    const imgStyle: CSSProperties = {
        maxWidth: '100%',
    };

    // -> THIS WAS THE MISSING LINE <-
    const r2BaseUrl = process.env.REACT_APP_R2_BASE_URL || '';

    return (
        <>
            <h1 style={titleStyle}>
                {displayMusic && displayMusic
                    .replace('김일성','')
                    .replace('김정일','')
                    .replace('김정은','')}
            </h1>
            <div style={musicStyle}>
                <audio
                    style={audioStyle}
                    controls
                    src={`${r2BaseUrl}/music/audio/${no}.mp3`} />
                <img
                    style={imgStyle}
                    src={`${r2BaseUrl}/music/image/${no}.jpg`}
                    alt='화상'
                    onError={(e) => {
                        // Make sure the fallback GIF also points to Cloudflare R2!
                        if (e.currentTarget.src.endsWith('.jpg')) {
                            e.currentTarget.src = `${r2BaseUrl}/music/image/${no}.gif`;
                        } else {
                            e.currentTarget.onerror = null;
                        }
                    }}
                />
            </div>
        </>
    );
}

export default ViewMusic;
